import type { GameState } from '../game/types';

export interface Assistant {
  id: string;
  name: string;
  description: string;
  /** 该助理解锁后开放的扩展功能 id 列表 */
  featureIds: string[];
  /** 返回 true 时该助理会在每周模拟后自动解锁（仍可招募） */
  unlocked: (state: GameState) => boolean;
  /** 解锁条件文案，用于在 UI 中明确展示 */
  unlockRequirement: string;
  /** 招募一次性费用 */
  recruitCost: number;
  /** 每周薪资 */
  weeklySalary: number;
}

export interface AssistantFeature {
  id: string;
  name: string;
  description: string;
  assistantId: string;
}

export function isAssistantUnlocked(state: GameState, assistantId: string): boolean {
  return state.assistants.unlockedIds.includes(assistantId) && !state.assistants.dismissedIds.includes(assistantId);
}

export function isAssistantHired(state: GameState, assistantId: string): boolean {
  return state.assistants.hired.some((h) => h.id === assistantId && h.active);
}

export function isFeatureEnabled(state: GameState, featureId: string, assistant: Assistant): boolean {
  return assistant.featureIds.includes(featureId) && isAssistantHired(state, assistant.id);
}
